import { paymentsApi } from '.';

export interface StripeExecuteTransactionRequest {
  client: string,
  payment_method_id: string,
  transactionId: string,
  account_identifier: string,
  amount: number,
  currency: string,
}

export interface StripeExecuteIntentRequest {
  client: string,
  payment_intent_id: string,
  transactionId: string,
  account_identifier: string,
}

export type StripeExecuteRequest = StripeExecuteTransactionRequest | StripeExecuteIntentRequest;

export interface StripeExecuteData {
  payment_intent_client_secret?: string,
  requires_action?: boolean,
}

export interface StripeExecuteResponse {
  data: StripeExecuteData,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    stripeExecute: builder.mutation<StripeExecuteResponse, StripeExecuteRequest>({
      query: body => ({
        url: 'provider/stripe/execute',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useStripeExecuteMutation } = extendedPaymentsApi;
